<template>
    <div>
		<div class="experience-card">
			<h3>Lead Product Manager (Consultancy and SaaS)</h3>
			<h5><i>MadeTech</i> | <i>August 2023 to present</i> | <i>Internal promotion</i></h5>
			<ul><li><b>SaaS</b> - Led lean team in experimental approach to introducing a new 'zero to one'
<a href="https://voids.madetech.com/">B2B social housing product</a></li>

			<li><b>SaaS</b> - Led user research into needs of our customers to ensure accurate value propositions were made</li>
			<li><b>SaaS</b> - Conducted outreach to customers and established marketing, GTM and pricing tactics</li>
			<li><b>SaaS</b> - Set strategic focus and roadmap for the product</li>
			<li><b>SaaS</b> - Public face of the product, hosting webinar discussion panels and representing the company at conferences</li>
			<li><b>SaaS</b> - Created online Housing Best Practice community</li>
			<li><b>Consultancy</b> - Managed cross functional teams throughout software development lifecycle</li>
			<li><b>NHS</b> - Delivered strategy document for NHS England GP2GP API</li>
			<li><b>Home Office</b> - Developed project playbook for Home Office MAPPS reporting function</li>

			</ul>
		</div>
		<div class="experience-card">
			<h3>Senior Product Manager (Consultancy)</h3>
			<h5><i>MadeTech</i> | <i>Jan 2022 to August 2023</i></h5>
			<ul>
				<li>Delivered DVLA data lake & discovery on NHS data API product</li>
				<li>Liaised with senior DVLA officials on data strategy to agree product strategy and agree with Director stakeholders</li>
				<li>Jointly established Community of Practice with Head of Product</li>
				<li>Coached client delivery teams in agile practice including moving to iterative fortnightly releases, and user focussed tickets</li>
				<li>Line managed 2 Product Managers to successful promotion</li>

			</ul>
		</div>
		<div class="experience-card">
			<h3>Senior Product Manager (Startup)</h3>
			<h5><i>Arctoris</i> | <i>Aug 2021 to Jan 2022</i></h5>
			<ul>
				<li>As first product hire, oversaw the delivery of Arctoris' first automated drug discovery reporting line, allowing for 80% of revenue to be automated</li>
			</ul>
		</div>
		<div class="experience-card">
			<h3>Senior Product Manager (Startup/Scaleup)</h3>
			<h5><i>Zen Educate</i> | <i>Jan 2020 to Aug 2021</i></h5>
			<ul>
				<li>Managed three teams of 4 (web, mobile, API) to deliver higher automation, over 1,000,000 transactions for marketplace app, reporting to C-suite</li>
				<li>Led user research sessions with schools and teachers to improve UI/UX resulting in 30% reduction in 'time-to-book' KPI</li>
				<li>Complete management of backlog and sprint planning process</li>
				<li>Integrated with Optimizely for A/B testing</li>
				<li>Led continuous improvement work on ‘teacher discovery’ algorithm</li>
			</ul>
		</div>

		<div class="experience-card">
			<h3>Head of Digital Organising (Interim)</h3>
			<h5><i>The Labour Party</i> | <i>Jan 2019 to Jun 2019</i></h5>
			<ul>
				<li>Delivered, and managed the cross-functional team of 7 that delivered 5 'zero to one' <a href="https://labour.org.uk/members/activist-area/tools-for-activists/">applications that mobilised 100,000s of volunteers</a> and millions of voters.</li>
			</ul>
		</div>
		
		<div class="experience-card">
			<h3>Further experience</h3>
			<i><h5>2012 to present</h5></i>
			<ul>
				<li>Product Manager - The Labour Party</li>
				<li>Campaign Manager - Gemma Doyle MP</li>
				<li>West of Scotland Campaign Manager - Better Together</li>
				<li>Freelance Web Developer - Multiple Clients</li>
			</ul>
		</div>

		<div class="experience-card">
			<h3>University of Glasgow</h3>
			<h5><i>LL.B in Law with Honours</i> | <i>'08 to '12</i></h5>
			<ul>
				<li>Upper Second Class Degree in Law.</li>
			</ul>
		</div>
    </div>
</template>


<script>

	export default {
		name: "ExperienceDetails"
		}

</script>


<style>
.experience-card {
  text-align: left;
  padding-bottom: 20px;
    max-width: 70%;
    min-width: 70%;
    margin: 0 auto;

}

li {
	padding-bottom: 7px;
}

@media only screen and (max-width: 767px) {
	.experience-card h3 {
		text-align: center;
	}
}

@media only screen and (max-width: 767px) {
	.experience-card h5 {
		text-align: center;
	}
}
</style>
